import moment from 'moment-timezone';

//This helper function converts time to NSW time
export const toSydneyTime = (timeStr: string, state: string): string => {
  const timeZones: { [key: string]: string } = {
    'Australian Capital Territory': 'Australia/Sydney',
    Queensland: 'Australia/Brisbane',
    'New South Wales': 'Australia/Sydney',
    'Northern Territory': 'Australia/Darwin',
    'South Australia': 'Australia/Adelaide',
    Tasmania: 'Australia/Hobart',
    Victoria: 'Australia/Melbourne',
    'Western Australia': 'Australia/Perth',
  };

  const timezone = timeZones[state] || '';

  const dateTimeWithoutOffset = moment(timeStr).format('YYYY-MM-DDTHH:mm:ss');

  if (!moment(dateTimeWithoutOffset).isValid() || !timezone) {
    console.error('Invalid date:', timeStr);
    return timeStr;
  }

  const dateWithTimeZone = moment.tz(dateTimeWithoutOffset, timezone).format();
  const sydneyTime = moment.tz(dateWithTimeZone, 'Australia/Sydney').utc().format();

  return sydneyTime;
};
